<!-- Header -->
<app-header></app-header>


<main class="main" (click)="fecharMenuAcessibilidade()">

    <div class="elemento-imagem" #element *ngFor="let item of this.linguagensImagens" [style.backgroundImage]="'url('+ item.Imagem +')'"></div>
    <router-outlet></router-outlet>

</main>

<!-- Footes -->
<app-footer></app-footer>

<app-botao-scroll-top></app-botao-scroll-top>
<app-botao-denuncias></app-botao-denuncias>